module.exports = __webpack_public_path__ + "img/home_icon.9dc73a44.svg";